module.exports = __webpack_public_path__ + "static/Square-Banner.6d35a8c3.jpg";